import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=65f41809&scoped=true&"
import script from "./Application.vue?vue&type=script&lang=ts&"
export * from "./Application.vue?vue&type=script&lang=ts&"
import style0 from "./Application.vue?vue&type=style&index=0&id=65f41809&scoped=true&lang=css&"
import style1 from "./Application.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f41809",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VMain,VSlideXReverseTransition})
